import Vue from 'vue'
import LightBootstrap from './light-bootstrap-main'
// Plugins
import App from './App.vue'
import router from './routes'
import store from './store'
import {utils} from "./utils";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome"
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

library.add(
  fas,
  far
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// plugin setup
Vue.use(LightBootstrap)

Vue.filter('capitalize', (value) => utils.capitalize(value))
Vue.filter('rutFormat', (value) => utils.rutFilter(value))

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

